/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Metadata_YesInputs */



/**
* | output |
* | --- |
* | "Yes" |
*
* @param {Iconik_Metadata_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_metadata_yes = /** @type {((inputs?: Iconik_Metadata_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Metadata_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Yes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Yes")
	if (locale === "it") return /** @type {LocalizedString} */ ("Yes")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Yes")
	if (locale === "es") return /** @type {LocalizedString} */ ("Yes")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("Yes")
	if (locale === "ja") return /** @type {LocalizedString} */ ("Yes")
	if (locale === "hi") return /** @type {LocalizedString} */ ("Yes")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Yes")
	return /** @type {LocalizedString} */ ("Yes")
});